import Key from "csi/core/Key";
import Specs from "csi/heading/Specs";
import locale from "csi/locale";
import csi from "csi/main";
import { C8Node, ICache } from "csi/typings";
import xml from "csi/xml";

/** Maps value types to the optional attributes on the SpecificationDataSheetItem */
export const specValueIdMap: object = {
	[xml.ATTR_REF]: "ValueLookupItem",
	[xml.ATTR_REFLIST]: "ValueLookupItemList",
	[xml.ATTR_BOOLEAN]: "ValueBoolean",
	[xml.ATTR_DOUBLE]: "ValueDouble",
	[xml.ATTR_INTEGER]: "ValueInt",
	[xml.ATTR_STRING]: "ValueString",
};

type SpecAvailability = {
	/** indicate if the matrix SharedSectionItemMap is chosen and available  */
	specItemIsAvailable: boolean;

	/** indicate if the matrix SharedSpecItemDefinitionMap is chosen and available  */
	specSectionIsAvailable: boolean;
}

/** check the availability of the matrices related to shared spec/item  */
export function getMatrixPresence(attributeSpecs: Specs): SpecAvailability {
	const specItemIsAvailable = !!attributeSpecs?.find({ id: "SharedSpecItemDefinitionMap" });
	const specSectionIsAvailable = !!attributeSpecs?.find({ id: "SharedSectionItemMap" });

	return {
		specItemIsAvailable,
		specSectionIsAvailable,
	};
}

/** sort the spec item nodes */
export function sortSpecItemNodes(nodes: C8Node[], sortAttr: string, cache: ICache): C8Node[] {
	if (!sortAttr) {
		return xml.sortNodes(nodes);
	}

	return csi.sort(nodes, (defn) => {
		const value = defn[sortAttr];
		const refNode = cache.get(value);

		return refNode ? locale.getNodeName(refNode, cache) : value;
	});
}